<template>
  <div class="register-container">
    <div class="register-card">
      <div class="register-header">
        <h2>用户注册</h2>
        <p>请选择注册方式</p>
      </div>

      <!-- 注册方式切换 -->
      <div class="register-tabs">
        <div 
          class="tab-item" 
          :class="{ active: registerType === 'phone' }"
          @click="switchRegisterType('phone')"
        >
          <i class="phone-icon">📱</i>
          手机号注册
        </div>
        <div 
          class="tab-item" 
          :class="{ active: registerType === 'wechat' }"
          @click="switchRegisterType('wechat')"
        >
          <i class="wechat-icon">💬</i>
          微信注册
        </div>
      </div>

      <!-- 手机号注册表单 -->
      <div v-if="registerType === 'phone'" class="register-form">
        <div class="form-group">
          <label>手机号</label>
          <input 
            type="tel" 
            v-model="phoneForm.phone" 
            placeholder="请输入手机号"
            maxlength="11"
          />
        </div>
        
        <div class="form-group">
          <label>验证码</label>
          <div class="code-input-group">
            <input 
              type="text" 
              v-model="phoneForm.code" 
              placeholder="请输入验证码"
              maxlength="6"
            />
            <button 
              class="send-code-btn" 
              @click="sendCode"
              :disabled="countdown > 0"
            >
              {{ countdown > 0 ? `${countdown}s` : '发送验证码' }}
            </button>
          </div>
        </div>

        <div class="form-group">
          <label>密码</label>
          <input 
            type="password" 
            v-model="phoneForm.password" 
            placeholder="请输入密码（6-20位）"
          />
        </div>

        <div class="form-group">
          <label>确认密码</label>
          <input 
            type="password" 
            v-model="phoneForm.confirmPassword" 
            placeholder="请再次输入密码"
          />
        </div>

        <div class="form-group">
          <label class="checkbox-label">
            <input type="checkbox" v-model="phoneForm.agree" />
            <span>我已阅读并同意</span>
            <a href="#" @click.prevent="showAgreement">《用户协议》</a>
            <span>和</span>
            <a href="#" @click.prevent="showPrivacy">《隐私政策》</a>
          </label>
        </div>

        <button class="register-btn" @click="registerByPhone">注册</button>
      </div>

      <!-- 微信注册 -->
      <div v-if="registerType === 'wechat'" class="wechat-register">
        <div class="wechat-qr-container">
          <div class="qr-code">
            <div class="qr-placeholder">
              <i class="qr-icon">📱</i>
              <p>微信扫码注册</p>
            </div>
          </div>
          <p class="qr-tip">请使用微信扫描二维码完成注册</p>
        </div>
        
        <div class="wechat-options">
          <button class="wechat-btn" @click="openWechatApp">
            <i class="wechat-icon">💬</i>
            打开微信APP
          </button>
          <button class="refresh-btn" @click="refreshQRCode">
            <i class="refresh-icon">🔄</i>
            刷新二维码
          </button>
        </div>
      </div>

      <!-- 登录链接 -->
      <div class="login-link">
        已有账号？<a href="#" @click.prevent="goToLogin">立即登录</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserRegister',
  data() {
    return {
      registerType: 'phone', // 'phone' 或 'wechat'
      countdown: 0,
      phoneForm: {
        phone: '',
        code: '',
        password: '',
        confirmPassword: '',
        agree: false
      }
    }
  },
  methods: {
    // 切换注册方式
    switchRegisterType(type) {
      this.registerType = type;
    },

    // 发送验证码
    sendCode() {
      if (!this.phoneForm.phone) {
        alert('请输入手机号');
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.phoneForm.phone)) {
        alert('请输入正确的手机号');
        return;
      }

      // 开始倒计时
      this.countdown = 60;
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);

      // 这里可以调用发送验证码的API
      alert('验证码已发送到您的手机');
    },

    // 手机号注册
    registerByPhone() {
      if (!this.validatePhoneForm()) {
        return;
      }

      // 这里可以调用注册API
      alert('注册成功！');
      this.$router.push('/customer/login');
    },

    // 验证手机号注册表单
    validatePhoneForm() {
      if (!this.phoneForm.phone) {
        alert('请输入手机号');
        return false;
      }
      if (!/^1[3-9]\d{9}$/.test(this.phoneForm.phone)) {
        alert('请输入正确的手机号');
        return false;
      }
      if (!this.phoneForm.code) {
        alert('请输入验证码');
        return false;
      }
      if (!this.phoneForm.password) {
        alert('请输入密码');
        return false;
      }
      if (this.phoneForm.password.length < 6 || this.phoneForm.password.length > 20) {
        alert('密码长度应为6-20位');
        return false;
      }
      if (this.phoneForm.password !== this.phoneForm.confirmPassword) {
        alert('两次输入的密码不一致');
        return false;
      }
      if (!this.phoneForm.agree) {
        alert('请同意用户协议和隐私政策');
        return false;
      }
      return true;
    },

    // 打开微信APP
    openWechatApp() {
      // 这里可以调用微信SDK或跳转到微信
      alert('正在打开微信...');
    },

    // 刷新二维码
    refreshQRCode() {
      alert('二维码已刷新');
    },

    // 显示用户协议
    showAgreement() {
      alert('用户协议内容');
    },

    // 显示隐私政策
    showPrivacy() {
      alert('隐私政策内容');
    },

    // 跳转到登录页
    goToLogin() {
      this.$router.push('/customer/login');
    }
  }
}
</script>

<style scoped>
.register-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.register-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  padding: 40px;
  width: 100%;
  max-width: 400px;
}

.register-header {
  text-align: center;
  margin-bottom: 30px;
}

.register-header h2 {
  color: #333;
  margin: 0 0 10px 0;
  font-size: 24px;
}

.register-header p {
  color: #666;
  margin: 0;
  font-size: 14px;
}

.register-tabs {
  display: flex;
  margin-bottom: 30px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}

.tab-item {
  flex: 1;
  padding: 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f8f9fa;
  border-right: 1px solid #e0e0e0;
  font-size: 14px;
}

.tab-item:last-child {
  border-right: none;
}

.tab-item.active {
  background: #42b983;
  color: white;
}

.tab-item i {
  margin-right: 5px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-size: 14px;
  font-weight: 500;
}

.form-group input[type="tel"],
.form-group input[type="text"],
.form-group input[type="password"] {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
}

.form-group input:focus {
  outline: none;
  border-color: #42b983;
}

.code-input-group {
  display: flex;
  gap: 10px;
}

.code-input-group input {
  flex: 1;
}

.send-code-btn {
  padding: 12px 16px;
  background: #42b983;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
  transition: background-color 0.3s ease;
}

.send-code-btn:hover:not(:disabled) {
  background: #3aa876;
}

.send-code-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.checkbox-label {
  display: flex !important;
  align-items: center;
  font-size: 14px;
  color: #666;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  margin-right: 8px;
  width: auto;
}

.checkbox-label a {
  color: #42b983;
  text-decoration: none;
}

.checkbox-label a:hover {
  text-decoration: underline;
}

.register-btn {
  width: 100%;
  padding: 14px;
  background: #42b983;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 10px;
}

.register-btn:hover {
  background: #3aa876;
}

.wechat-register {
  text-align: center;
}

.wechat-qr-container {
  margin-bottom: 30px;
}

.qr-code {
  width: 200px;
  height: 200px;
  margin: 0 auto 20px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-placeholder {
  text-align: center;
  color: #666;
}

.qr-icon {
  font-size: 48px;
  margin-bottom: 10px;
  display: block;
}

.qr-tip {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.wechat-options {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.wechat-btn,
.refresh-btn {
  padding: 10px 20px;
  border: 1px solid #42b983;
  border-radius: 6px;
  background: white;
  color: #42b983;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.wechat-btn:hover,
.refresh-btn:hover {
  background: #42b983;
  color: white;
}

.login-link {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: #666;
}

.login-link a {
  color: #42b983;
  text-decoration: none;
}

.login-link a:hover {
  text-decoration: underline;
}
</style>
